module.exports = __webpack_public_path__ + "img/37.a162a2a4.svg";